export default __webpack_public_path__ + "static/media/mainGlobe.5e0427e9.svg";